(ns motorsaif.web.pages.edit-request
  (:require
   [goog.string :refer [format]]
   [clojure.string :as str]
   [motorsaif.web.forms.request :as request-form]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.data-utils :as data-utils]
   [motorsaif.web.utils :as web-utils]
   [motorsaif.validation :as validation]
   [motorsaif.web.components :as c]
   [motorsaif.log :as log]
   [re-frame.core :as rf :refer [dispatch subscribe]]))

(defn root []
  (let [{:keys [request-id]} @(subscribe [:route/parameters])
        *request (subscribe [:request request-id])
        request (data-utils/wrap-results @*request)
        {short-id :short/id
         :request/keys [object status description category coords geo-location whatsapp media location type]} request

        {loc-name :location/name} location
        {category-id :db/id
         category :tag/title} category

        part-condition (get-in @*request [:part/condition :db/ident])

        init-data {:request (-> {:db/id request-id
                                 :request/description description
                                 :request/coords coords
                                 :request/geo-location geo-location
                                 :request/location (:db/id location)
                                 :request/type type
                                 :request/category category-id}
                                (data-utils/assoc-if-val :request/whatsapp whatsapp)
                                (data-utils/assoc-if-val :part/condition part-condition)
                                (data-utils/assoc-if-val :request/media media))
                   :car (with-meta {:db/id (:db/id object)} {:replace true})}

        form-key :edit-request

        on-submit
        (fn [{:keys [all-data new-data]}]
          (let [new-media (vec (remove nil? (get-in new-data [:request :request/media])))
                new-data (-> new-data
                             (update-in [:request :request/type] (fn [new-type] (or new-type type)))
                             (cond-> (seq new-media)
                               (assoc-in [:request :request/media] new-media)))
                ;; (update-in new-data [:request :request/media] #(vec (remove nil? %)))
                req {:type          :PUT
                     :url           "/api/requests"
                     :params        {:data (-> new-data (assoc-in [:request :db/id] request-id))}
                     :id            :new-request
                     :handler       (fn [{:keys [success ex-message] :as res}]
                                      (if success
                                        (do
                                          (rf/dispatch [:common/navigate! :request {:id request-id}])
                                          (rf/dispatch [:toast {:type    "success"
                                                                :message "Request saved!"}])
                                          (web-utils/scroll-top))
                                        (rf/dispatch
                                         [:toast {:type    "error"
                                                  :message (format "Failed to saved %s: " ex-message)}])))
                     :error-handler (fn [res]
                                      (println "Error creating"))}]
            (rf/dispatch [:do-ajax req])))

        make-form-args
        {:schema validation/edit-request

         ;; Does not handle valid values
         :change-watch #(dispatch [:reset-form form-key %])
         :on-submit {:valid on-submit
                     :invalid
                     (fn [error]
                       (let [error-titles ((:error-titles-fn error) :new-request)]
                         (rf/dispatch [:toast {:type "error"
                                               :timeout 5000
                                               :title (tr :page.edit-request.submit.invalid/title)
                                               :message (str/join ", " error-titles)}])))}
         :init-data init-data}]
    [:div.wrap
     [:div.container.med
      [c/header-with-back
       (tr :page.edit-request/header)
       {:subtitle
        [:span.bold (format "#%s" short-id)]}]
      [request-form/form {:make-form-args make-form-args
                          :form-key form-key}]]]))

(comment
  (subscribe [:ajax-status :bootstrap-data])
  (dispatch [:reset-form :request nil]))
